<template>
    <span class="ui-datetime-local">
        <input type="datetime-local"
            :value="value" 
            :name="name" 
            :class="className" 
            :readonly="readonly" 
            :autocomplete="autocomplete" 
            :max="max" 
            :min="min" 
            :step="step" 
            :required="required" 
            :list="list"
            @change="change"
            @input="input"
        />
    </span>
</template>

<script>
export default {
    name: "ui-datetime-local",
    props: {
        name: {type:String, default:""},
        source: {type:String, default:""},
        max: {type:String, default:""},
        min: {type:String, default:""},
        step: {type:String, default:""},
        readonly: {type:Boolean, default: false},
        required: {type:Boolean, default: false},
        autocomplete: {type:String, default:"default"},
        list: {type:String, default:""},
        className: {type:String, default:undefined}
    },
    data() {
        return {
            value: ""
        }
    },
    watch: {
        source(n, o) {
            this.value = this.cvtSource(n);
        }
    },
    mounted() {
        this.value = this.cvtSource(this.source);
    },
    methods: {
        change(e) {
            this.$emit('change', e);
        },
        input(e) {
            this.value = e.target.value;
            this.$emit('input', e);
        },
        cvtSource(source) {
            let result = "";
            if (source != "" && source != undefined) {
                if (source.split(" ").length > 1) {
                    result = source.split(" ")[0]+"T"+source.split(" ")[1];
                } else {
                    result = source+"T00:00";
                }
            }
            return result;
        }
    }
}
</script>

<style>

</style>